'use strict';

import 'angular';

import queryDirective from './query';
import skipDirective from './skip';
import filterDirective from './filter';
import fetchDirective from './fetch';

const MODULE_NAME = 'brg.rest.query';

var app = angular.module(MODULE_NAME, []);
app.directive('brgRestQuery', queryDirective);
app.directive('brgRestQueryPrevious', skipDirective('previous'))
app.directive('brgRestQueryNext', skipDirective('next'));
app.directive('brgRestQueryFilter', filterDirective);
app.directive('brgRestFetch', fetchDirective);

export default MODULE_NAME;
